"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cancel = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Cancel = function Cancel(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({
    viewBox: "0 0 15 14",
    transform: "rotate(0)"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.40986 6.99915L13.7061 1.71288C14.098 1.32104 14.098 0.685729 13.7061 0.293884C13.3143 -0.0979614 12.679 -0.0979614 12.2871 0.293884L7.00085 5.59014L1.71459 0.293884C1.32274 -0.0979613 0.687435 -0.0979613 0.29559 0.293884C-0.0962558 0.685729 -0.0962558 1.32104 0.29559 1.71288L5.59185 6.99915L0.29559 12.2854C0.106411 12.473 0 12.7285 0 12.9949C0 13.2614 0.106411 13.5168 0.29559 13.7044C0.483224 13.8936 0.738639 14 1.00509 14C1.27154 14 1.52695 13.8936 1.71459 13.7044L7.00085 8.40815L12.2871 13.7044C12.4748 13.8936 12.7302 14 12.9966 14C13.2631 14 13.5185 13.8936 13.7061 13.7044C13.8953 13.5168 14.0017 13.2614 14.0017 12.9949C14.0017 12.7285 13.8953 12.473 13.7061 12.2854L8.40986 6.99915Z"
  }));
};

exports.Cancel = Cancel;